import { render, staticRenderFns } from "./QuestionPublishDialog.vue?vue&type=template&id=9cc08052&scoped=true"
import script from "./QuestionPublishDialog.vue?vue&type=script&lang=js"
export * from "./QuestionPublishDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc08052",
  null
  
)

export default component.exports